var React = require('react');

function ListNode (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M17.777 19C16.8675 23.008 13.2832 26 9 26C4.02944 26 0 21.9706 0 17C0 12.0294 4.02944 8 9 8C13.2832 8 16.8675 10.992 17.777 15H31C32.1046 15 33 15.8954 33 17C33 18.1046 32.1046 19 31 19H17.777ZM9 22.4C6.01766 22.4 3.6 19.9823 3.6 17C3.6 14.0177 6.01766 11.6 9 11.6C11.9823 11.6 14.4 14.0177 14.4 17C14.4 19.9823 11.9823 22.4 9 22.4Z","fill":"#5186EE"}));
}

ListNode.defaultProps = {"width":"33","height":"33","viewBox":"0 0 33 33","fill":"none"};

module.exports = ListNode;

ListNode.default = ListNode;
